const config = {
  apiUrl: process.env.REACT_APP_API_URL,
  oauthClientId: process.env.REACT_APP_OAUTH_CLIENT_ID,
  oauthClientSecret: process.env.REACT_APP_OAUTH_CLIENT_SECRET,
  stripePublishableKey: process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY,
  googleAuthClientId: process.env.REACT_APP_GOOGLE_AUTH_CLIENT_ID,
}

export default config
